<template>
  <div>
    <Generic_Translations
      v-if='openProductTranslations'
      :columns="productColumns"
      :translations="productTranslations"
      @closeTranslations="closeProductTranslations"
      @saveTranslations="saveProductTranslations"
      ></Generic_Translations>
    <v-flex v-if="!openAddProduct" class="pl-2 mb-4 mt-2 pr-2">
      <v-layout align-start justify-start row class="mb-4">
        <v-icon color="primary" style="font-size: 50px;">shopping_cart</v-icon>
        <h2
          :style="`color: ${$vuetify.theme.primary}`"
          class="mt-2 ml-2"
        >{{ $translate("PRODUCTS") }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="disableAdd"
          fab
          right
          color="secondary"
          @click="addProduct"
        >
          <v-icon>add</v-icon>
        </v-btn>

        <v-dialog v-model="deleteProductDialog" max-width="290" hide-overlay>
          <v-card>
            <v-card-title class="headline">
              {{
              $translate("PRODUCT_DELETE")
              }}
            </v-card-title>
            <v-card-text>
              {{ $translate("PRODUCT_CONF_DELETE") }}
              <i>{{ productToBeDelete.Name }}</i> ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                round
                color="secondary"
                @click.native="deleteProductDialog = false"
              >{{ $translate("CANCEL") }}</v-btn>
              <v-btn round color="primary" @click.native="deleteProduct()">
                {{
                $translate("YES")
                }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="deleteProductAspectDialog" max-width="290" hide-overlay>
          <v-card>
            <v-card-title class="headline">
              {{
              $translate("PRODUCT_ASPECT_DELETE")
              }}
            </v-card-title>
            <v-card-text>
              {{ $translate("PRODUCT_ASPECT_CONF_DELETE") }}
              <i>{{ aspectToBeDeleted.Name }}</i> ?
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                round
                color="secondary"
                @click.native="deleteProductAspectDialog = false"
              >{{ $translate("CANCEL") }}</v-btn>
              <v-btn
                round
                color="primary"
                @click.native="deleteProductAspect(aspectToBeDeleted)"
              >{{ $translate("YES") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="deleteProductItemDialog" max-width="290" hide-overlay>
          <v-card>
            <v-card-title class="headline">
              {{
              $translate("PRODUCT_ITEM_DELETE")
              }}
            </v-card-title>
            <v-card-text>{{ $translate("PRODUCT_ITEM_CONF_DELETE") }}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                round
                color="secondary"
                @click.native="deleteProductItemDialog = false"
              >{{ $translate("CANCEL") }}</v-btn>
              <v-btn
                round
                color="primary"
                @click.native="deleteProductItem(itemToBeDeleted)"
              >{{ $translate("YES") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-spacer></v-spacer>
      <v-data-table
        :headers="headers"
        :items="filteredProductList"
        class="elevation-1"
        :rows-per-page-items="[10]"
      >
        <template v-slot:items="props">
          <td>
            <!--out of stock product switch-->
            <v-switch
              color="primary"
              :input-value="props.item.Capacity !== 0 ? true : false"
              @change="outOfStockProducts(props.item)"
              class="mx-2"
            ></v-switch>
          </td>
          <td>{{ props.item.Name }}</td>
          <td class="text-xs-center">{{ props.item.TagsString }}</td>
          <td class="text-xs-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  @click="openAspectsDialog(props.item)"
                  v-if="eventConfig.type !== 'Rental'"
                >bookmarks</v-icon>
                <v-icon v-else>bookmarks</v-icon>
              </template>
              <span>{{ props.item.ItemDefString }}</span>
            </v-tooltip>
          </td>
          <td class="text-xs-center">
            <v-icon @click="openItemsDialog(props.item)">shopping_cart</v-icon>
          </td>
          <td class="text-xs-center">
            <v-icon @click="openDiscountDialog(props.item)">local_offer</v-icon>
          </td>
          <td class="justify-center">
            <v-btn
              small
              class="v-btn-tiny mr-2"
              color="primary"
              @click="viewProductDetails(props.item)"
            >
              <v-icon small>border_color</v-icon>
            </v-btn>
            <v-btn
              small
              class="v-btn-tiny mr-2"
              color="primary"
              @click="getProductTranslations(props.item)"
            >
              <v-icon small>language</v-icon>
            </v-btn>
            <v-btn
              :disabled="disableAdd"
              small
              class="v-btn-tiny"
              color="primary"
              @click="showDeleteProductDialog(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex v-else>
      <v-dialog v-model="deleteProductPriceCategoryDialog" max-width="290" hide-overlay>
        <v-card>
          <v-card-title class="headline">
            {{
            $translate("PRODUCT_PRICE_CATEGORY_DELETE")
            }}
          </v-card-title>
          <v-card-text>{{ $translate("PRODUCT_PRICE_CATEGORY_CONF_DELETE") }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              round
              color="secondary"
              @click.native="deleteProductPriceCategoryDialog = false"
            >{{ $translate("CANCEL") }}</v-btn>
            <v-btn
              round
              color="primary"
              @click.native="deleteProductPriceCategory(priceCategoryToBeDeleted)"
            >{{ $translate("YES") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteExternalCalendarDialog" max-width="290" hide-overlay>
        <v-card>
          <v-card-title class="headline">
            {{
            $translate("EXTERNAL_CALENDAR_DELETE")
            }}
          </v-card-title>
          <v-card-text>{{ $translate("EXTERNAL_CALENDAR_CONF_DELETE") }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              round
              color="secondary"
              @click.native="deleteExternalCalendarDialog = false"
            >{{ $translate("CANCEL") }}</v-btn>
            <v-btn
              round
              color="primary"
              @click.native="deleteExternvalCalendar(externalCalendarToBeDeleted)"
            >{{ $translate("YES") }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="errorDialog" max-width="290" persistent>
        <v-card>
          <v-card-title class="headline">
            {{
            $translate("ERROR")
            }}
          </v-card-title>
          <v-card-text>{{ $translate("FORM_VALIDATE_1_TITLE") }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn round color="primary" @click="errorDialog = false">
              {{
              $translate("NEXT")
              }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="openAddProduct" class="dialogClass" persistent max-width="1200">
        <v-card class="elevation-1 dialogAddBG">
          <v-card class="elevation-0 transparent pa-4">
            <v-layout align-start justify-start row class="mb-4">
              <v-icon color="primary" style="font-size: 50px;">shopping_cart</v-icon>
              <h2
                v-if="editMode == true"
                :style="`color: ${$vuetify.theme.primary}`"
                class="mt-2"
              >{{ $translate("VIEW_PRODUCT") }}</h2>
              <h2
                v-else
                :style="`color: ${$vuetify.theme.primary}`"
                class="mt-2"
              >{{ $translate("CREATE_PRODUCT") }}</h2>
              <!-- <v-spacer></v-spacer> -->
            </v-layout>
            <v-layout column>
              <div class="scrollablleProductList">
                <v-form ref="productForm" v-model="valid" lazy-validation>

                  <v-subheader class="ml-2">{{ $translate('GENERAL') }}</v-subheader>

                  <v-layout justify-space-around row>
                    <v-flex xs5>
                      <v-layout row align-center>
                        <h3>Name</h3>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                      </v-layout>
                      <v-text-field
                        outline
                        :label="$translate('PRODUCT_NAME')"
                        v-model="productForm.Name"
                        item-text="label"
                        item-value="value"
                        :rules="textRule"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-layout row align-center>
                        <h3>{{$translate('VRI_CAPACITY')}}</h3>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                      </v-layout>
                      <v-text-field
                        outline
                        :label="$translate('PRODUCT_CAPACITY')"
                        v-model="productForm.Capacity"
                        item-text="label"
                        type="number"
                        item-value="value"
                        :rules="numberRule"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout v-if="eventConfig.type === 'Rental'" justify-left row>
                    <v-flex xs5 class="ml-4" v-if="eventConfig.type === 'Rental'">
                      <v-layout row align-center>
                        <h3>VAT</h3>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                      </v-layout>
                      <v-text-field
                        outline
                        :label="$translate('PRODUCT_VAT')"
                        v-model="productForm.VatPercentage"
                        item-text="label"
                        type="number"
                        item-value="value"
                        :rules="textRule"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-around row wrap>
                    <v-flex xs5 v-if="eventConfig.type !== 'Rental'">
                      <v-layout row align-center>
                        <h3>{{$translate('PRICE2')}}</h3>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                      </v-layout>
                      <v-text-field
                        outline
                        prepend-inner-icon="€"
                        :label="$translate('PRODUCT_PRICE')"
                        v-model="productForm.Price"
                        item-text="label"
                        type="number"
                        item-value="value"
                        :rules="textRule"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5 v-if="eventConfig.type !== 'Rental'">
                      <v-layout row align-center>
                        <h3>VAT</h3>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                      </v-layout>
                      <v-text-field
                        outline
                        :label="$translate('PRODUCT_VAT')"
                        v-model="productForm.VatPercentage"
                        item-text="label"
                        type="number"
                        item-value="value"
                        :rules="textRule"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs10 v-if="eventConfig.type === 'Rental'">
                      <h3 class="priceCategoriesCardTitle">{{$translate('EXTERNAL_CALENDAR')}}</h3>
                      <v-card class="elevation-0 priceCategoriesCard">
                        <v-toolbar flat color="white">
                          <v-spacer></v-spacer>
                          <v-btn
                            class="text-capitalize"
                            color="secondary"
                            round
                            @click="addNewExternalCalendar"
                          >{{$translate('EXTERNAL_CALENDAR_ADD')}}</v-btn>
                          <v-dialog v-model="externalCalendarDialog" max-width="670px" persistent>
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{$translate('EXTERNAL_CALENDAR_ADD')}}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                    <v-flex xs12 sm6 md5>
                                      <v-text-field
                                        v-model="editedExternalCalendarItem.Name"
                                        :label="$translate('NAME')"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md7>
                                      <v-text-field
                                        v-model="editedExternalCalendarItem.Url"
                                        label="Url"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-text-field
                                        v-model="editedExternalCalendarItem.CheckInTime"
                                        :label="$translate('EVENT_CHECK_IN_TIME')"
                                        type="time"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <v-text-field
                                        v-model="editedExternalCalendarItem.CheckOutTime"
                                        :label="$translate('EVENT_CHECK_OUT_TIME')"
                                        type="time"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12>
                                      <v-checkbox
                                        v-model="completeTime"
                                        :label="$translate('EVENT_ACTIVE_COMPLETE_TIME')"
                                      ></v-checkbox>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="secondary"
                                  round
                                  @click="closeExternalCalendardialog"
                                >{{$translate('CANCEL')}}</v-btn>
                                <v-btn
                                  color="primary"
                                  round
                                  @click="saveExternalCalendar"
                                >{{$translate('SAVE')}}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                        <v-data-table
                          :headers="externalCalendarHeaders"
                          :items="externalCalendarItems"
                          class="elevation-1"
                        >
                          <template v-slot:items="props">
                            <td>{{ props.item.Name }}</td>
                            <td :id="'exportUrl' + props.index">{{ props.item.ExportUrl }}</td>
                            <td>{{ props.item.CheckInTime }}</td>
                            <td>{{ props.item.CheckOutTime }}</td>
                            <td>{{props.item.CompleteTime ? 'On' : 'Off'}}</td>
                            <td class="justify-end layout px-0 mr-3">
                              <v-icon
                                small
                                class="mr-2"
                                @click="triggerEditExternalCalendar(props.item)"
                              >edit</v-icon>
                              <v-icon small @click="triggerDeleteExternalCalendar(props.item)">delete</v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-card>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-checkbox
                            v-model="productConfig.ExternalSynchronisation"
                            label="Activate export url"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs10>
                          <v-text-field
                            readonly
                            id="myInput"
                            v-model="productConfig.ExternalCalendarUrl"
                            outline
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                          <v-btn color="secondary"
                                 round
                                 @click="copyAutomatic">
                            {{$translate('COPY')}}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs10 v-if="eventConfig.type === 'Rental'">
                      <h3 class="priceCategoriesCardTitle">{{$translate('EVENT_PRICE_CATEGORY')}}</h3>
                      <v-card class="elevation-0 priceCategoriesCard">
                        <v-toolbar flat color="white">
                          <v-spacer></v-spacer>
                          <v-btn
                            class="text-capitalize"
                            color="secondary"
                            round
                            @click="addNewPriceCategory"
                          >{{$translate('EVENT_ADD_PRICE_CATEGORY')}}</v-btn>
                          <v-dialog v-model="priceCategoriesDialog" max-width="670px" persistent>
                            <v-card>
                              <v-card-title>
                                <span class="headline">{{ formTicketTitle }}</span>
                              </v-card-title>

                              <v-card-text>
                                <v-container grid-list-md>
                                  <v-layout wrap>
                                    <v-flex xs12 sm6 md7>
                                      <v-select
                                        v-if="!editPriceCategory"
                                        v-model="editedPriceCategoriesItem.Name"
                                        :items="potentialPriceCategories"
                                        item-text="Name"
                                        :label="$translate('NAME')"
                                        outline
                                      ></v-select>
                                      <v-text-field
                                        v-else
                                        disabled
                                        v-model="editedPriceCategoriesItem.Name"
                                        :label="$translate('NAME')"
                                      ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 md5>
                                      <v-text-field
                                        input="number"
                                        min="0"
                                        max="100"
                                        v-model="editedPriceCategoriesItem.Price"
                                        type="number"
                                        :label="$translate('PRICE2')"
                                        prefix="€"
                                      ></v-text-field>
                                    </v-flex>
                                  </v-layout>
                                </v-container>
                              </v-card-text>

                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="secondary"
                                  round
                                  @click="closePriceCategoriesdialog"
                                >{{$translate('CANCEL')}}</v-btn>
                                <v-btn
                                  color="primary"
                                  :disabled="potentialPriceCategories.length == 0"
                                  round
                                  @click="savePriceCategories"
                                >{{$translate('SAVE')}}</v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                        <v-data-table
                          :headers="priceCategoriesHeaders"
                          :items="batchgroupPriceCategories"
                          class="elevation-1"
                        >
                          <template v-slot:items="props">
                            <td>{{ props.item.Name }}</td>
                            <td>{{ props.item.Price }}</td>
                            <td class="justify-end layout px-0 mr-3">
                              <v-icon
                                small
                                class="mr-2"
                                @click="triggerEditPriceCategories(props.item)"
                              >edit</v-icon>
                              <v-icon small @click="triggerDeletePriceCategory(props.item)">delete</v-icon>
                            </td>
                          </template>
                        </v-data-table>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-around row>
                    <v-flex xs5>
                      <h3>{{$translate('EVENT_AGE_RESTRICTIO')}}n</h3>
                      <v-text-field
                        outline
                        :label="$translate('PRODUCT_AGE')"
                        v-model="productForm.ForAge"
                        item-text="label"
                        type="number"
                        item-value="value"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5>
                      <v-layout row align-center>
                        <h3>{{$translate('EVENT_CAT_SHORT')}}</h3>
                        <h5 class="requiredField">- {{$translate('REQUIRED')}}</h5>
                      </v-layout>
                      <v-select
                        outline
                        :label="$translate('PRODUCT_CATEGORY')"
                        v-model="productForm.ProductCategory"
                        :items="productCategories"
                        item-text="description"
                        item-value="id"
                        return-object
                        persistent-hint
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-around row>
                    <v-flex xs5>
                      <h3>{{$translate('EVENT_PIC_SHORT')}}</h3>
                      <event-image-loader
                        class="imageBorder"
                        :properties="properties2"
                        v-on:load_image="setImageElement"
                      ></event-image-loader>
                    </v-flex>
                    <v-flex xs5>
                      <h3>{{$translate('BRAND')}}</h3>
                      <v-text-field
                        outline
                        :label="$translate('PRODUCT_BRAND')"
                        v-model="productForm.Brand"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout justify-space-around row class="mt-4">
                    <v-flex xs5>
                      <h3>{{$translate('TYPE')}}</h3>
                      <v-select
                        outline
                        :label="$translate('PRODUCT_TYPE')"
                        v-model="productForm.Type"
                        :items="productTypes"
                        persistent-hint
                        :disabled="eventConfig.type !== 'Webshop'"
                      ></v-select>
                    </v-flex>
                    <v-flex xs5></v-flex>
                  </v-layout>

                  <!-- Weighted info for the type of 'Weighted' product -->
                  <v-flex v-if="productForm.Type === 'Weighted'">
                    <v-divider></v-divider>
                    <v-subheader class="ml-2">{{ $translate('WEIGHTED_INFO_HEADER') }}</v-subheader>

                    <v-layout row wrap justify-space-around>
                      <!-- Unit -->
                      <v-flex xs5>
                        <h3>{{$translate('UNIT_HEADER')}}</h3>
                        <v-text-field
                          outline
                          :label="$translate('UNIT_INFO')"
                          v-model="productForm.WeightedInfo.Unit"
                        ></v-text-field>
                      </v-flex>

                      <!-- Step Size -->
                      <v-flex xs5>
                        <h3>{{$translate('STEP_SIZE_HEADER')}}</h3>
                        <v-text-field
                          outline
                          :label="$translate('STEP_SIZE_INFO')"
                          v-model="productForm.WeightedInfo.StepSize"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <!-- Price Per Step -->
                      <v-flex xs5>
                        <h3>{{$translate('PRICE_PER_STEP_HEADER')}}</h3>
                        <v-text-field
                          outline
                          :label="$translate('PRICE_PER_STEP_INFO')"
                          v-model="productForm.WeightedInfo.PricePerStep"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <!-- Minimum Quantity -->
                      <v-flex xs5>
                        <h3>{{$translate('MINIMUM_QUANTITY_HEADER')}}</h3>
                        <v-text-field
                          outline
                          :label="$translate('MINIMUM_QUANTITY_INFO')"
                          v-model="productForm.WeightedInfo.Minimum"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <!-- Overview Size -->
                      <v-flex xs5>
                        <h3>{{$translate('OVERVIEW_SIZE_HEADER')}}</h3>
                        <v-text-field
                          outline
                          :label="$translate('OVERVIEW_SIZE_INFO')"
                          v-model="productForm.WeightedInfo.OverviewSize"
                          type="number"
                        ></v-text-field>
                      </v-flex>

                      <!-- Fixed Price -->
                      <v-flex xs5>
                        <h3>{{$translate('FIXED_PRICE_HEADER')}}</h3>
                        <v-checkbox
                          v-model="productForm.WeightedInfo.FixedPrice"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-form>
              </div>
            </v-layout>
            <v-layout row justify-end class="mt-1">
              <v-btn
                round
                color="secondary"
                @click="signalCloseProductDialog({})"
              >{{ $translate("CANCEL") }}</v-btn>
              <v-btn round color="primary" @click="savingProduct">
                {{
                $translate("SAVE")
                }}
              </v-btn>
            </v-layout>
          </v-card>
        </v-card>
      </v-dialog>
    </v-flex>
    <v-dialog persistent v-model="aspectsDialog" max-width="750">
      <v-layout column wrap>
        <v-card class="aspectsCard elevation-2">
          <v-card xs12 class="elevation-0 pa-2">
            <v-layout row>
              <v-icon>bookmarks</v-icon>
              <h2>{{$translate('ASPECTS')}}</h2>
            </v-layout>
          </v-card>
          <v-card xs12 class="pa-2 elevation-0">
            <v-card class="elevation-0 discountCard">
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="secondary"
                  round
                  @click="addNewProductAspect()"
                >{{$translate('NEW_ASPECT')}}</v-btn>
              </v-toolbar>
              <v-data-table :headers="aspectsHeader" :items="productAspects" class="elevation-1">
                <template v-slot:items="props">
                  <td>{{ props.item.Name }}</td>
                  <td class="text-xs-left">{{ props.item.ChoicesString }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon small class="mr-2" @click="editProductAspectItem(props.item)">edit</v-icon>
                    <v-icon small @click="triggerDeleteAspectDialog(props.item)">delete</v-icon>
                  </td>
                </template>
              </v-data-table>
              <v-layout class="mb-4 mr-4 mt-4" align-end justify-end row>
                <v-btn
                  round
                  color="secondary"
                  class="text-capitalize"
                  @click="cancelProductAspectsDialog()"
                >{{ $translate("CLOSE") }}</v-btn>
                <v-btn
                  round
                  color="primary"
                  class="text-capitalize"
                  @click="saveProductAspects()"
                >{{ $translate("SAVE") }}</v-btn>
              </v-layout>
            </v-card>
          </v-card>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="addProductAspect" max-width="350">
      <v-card>
        <v-card-title>
          <span class="headline">{{ productAspectTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-flex xs10>
                <h3>{{$translate('NAME')}}</h3>
                <v-text-field outline v-model="editedProductAspectItem.Name" label="Aspect name"></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-layout row wrap>
                  <h3>{{$translate('CHOICES')}}</h3>
                  <v-spacer></v-spacer>
                  <v-icon @click="addNewProductAspectChoice()">add</v-icon>
                </v-layout>
                <v-card class="choicesCard">
                  <v-card
                    class="elevation-0"
                    v-for="item in editedProductAspectItem.Choices"
                    :key="item"
                  >{{ item }}</v-card>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" round @click="closeAspectsDialog">{{$translate('CANCEL')}}</v-btn>
          <v-btn
            v-if="!editProductAspect"
            color="primary"
            round
            @click="saveProductAspectChoice(editedProductAspectItem)"
          >{{$translate('DONE')}}</v-btn>
          <v-btn
            v-else
            color="primary"
            round
            @click="editingProductAspectChoice(editedProductAspectItem)"
          >{{$translate('DONE')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addProductAspectChoice" max-width="350">
      <v-card>
        <v-card-title>
          <span class="headline">{{$translate('ADD_CHOICE')}}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-flex xs10>
                <h3>{{$translate('NAME')}}</h3>
                <v-text-field
                  outline
                  v-model="editedProductAspectChoiceItem.Name"
                  :label="$translate('NAME')"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" round @click="addProductAspectChoice = false">{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary"
            round
            @click="saveProductAspectChoiceTmp(editedProductAspectChoiceItem)"
          >{{ $translate("SAVE") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="itemsDialog" max-width="800">
      <v-layout column wrap>
        <v-card class="aspectsCard elevation-2">
          <v-card xs12 class="elevation-0 pa-2">
            <v-layout row>
              <v-icon>shopping_cart</v-icon>
              <h2>{{$translate('ITEMS')}}</h2>
            </v-layout>
          </v-card>
          <v-card xs12 class="pa-2 elevation-0">
            <v-card class="elevation-0 discountCard">
              <v-toolbar flat color="white">
                <v-spacer></v-spacer>
                <v-btn
                  class="text-capitalize"
                  color="secondary"
                  round
                  @click="addNewProductItem()"
                >{{$translate('ADD_ITEMS')}}</v-btn>
              </v-toolbar>
              <v-data-table :headers="itemsHeader" :items="productItems" class="elevation-1">
                <template v-slot:items="props">
                  <td>
                    <v-layout justify-center align-center>
                      <!--out of stock item switch-->
                      <v-switch
                        style="margin-bottom: -12px"
                        color="primary"
                        :input-value="props.item.Capacity !== 0 ? true : false"
                        @change="outOfStockItems(props.item)"
                      ></v-switch>
                    </v-layout>
                  </td>
                  <td>{{ props.item.Id }}</td>
                  <td class="text-xs-left">{{ props.item.AspectsString }}</td>
                  <td class="text-xs-left">{{ props.item.Price }}</td>
                  <td class="text-xs-left">{{ props.item.Capacity }}</td>
                  <td class="text-xs-left">{{ props.item.DiscountPercentage }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon small class="mr-2" @click="triggerEditProductItem(props.item)">edit</v-icon>
                    <v-icon small @click="triggerDeleteProductItem(props.item)">delete</v-icon>
                  </td>
                </template>
              </v-data-table>
              <v-layout class="mb-4 mr-4 mt-4" align-end justify-end row>
                <v-btn
                  round
                  color="secondary"
                  class="text-capitalize"
                  @click="cancelProductItemsDialog()"
                >{{ $translate("CLOSE") }}</v-btn>
              </v-layout>
            </v-card>
          </v-card>
        </v-card>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="addProductItem" max-width="750">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon>shopping_cart</v-icon>
            {{ productItemTitle }}
          </span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-layout justify-space-between wrap>
              <v-flex xs5 v-for="(item, index) in selectedProductForItems.ItemDefs" :key="index">
                <h3>{{ index }}</h3>
                <v-select
                  v-if="!editProductItem"
                  outline
                  v-model="item.Value"
                  item-value="Name"
                  item-text="Name"
                  :items="returnItemsInObject(item)"
                  :label="$translate('CHOOSE_AN_OPTION')"
                ></v-select>
                <v-select
                  v-else-if="editProductItem"
                  outline
                  v-model="item.Value"
                  item-value="Name"
                  :value="setVModel(index)"
                  item-text="Name"
                  :label="item"
                  :items="returnItemsInObject(item)"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout justify-space-between row wrap>
              <v-flex xs5>
                <h3>{{$translate('PRICE2')}}</h3>
                <v-text-field outline v-model="editedProductItemsItem.Price" :label="$translate('PRICE2')"></v-text-field>
              </v-flex>
              <v-flex xs5>
                <h3>{{$translate('EVENT_CAP_SHORT')}}</h3>
                <v-text-field outline v-model="editedProductItemsItem.Capacity" :label="$translate('EVENT_CAP_SHORT')"></v-text-field>
              </v-flex>
              <v-layout justify-space-between row wrap>
                <v-flex xs5>
                  <h3>{{$translate('EVENT_PIC_SHORT')}}</h3>
                  <event-image-loader
                    class="imageBorder"
                    :properties="itemPictureProperties"
                    v-on:load_image="setImageElementForItem"
                  ></event-image-loader>
                </v-flex>
                <v-flex xs5>
                  <h3>{{$translate('DISCOUNT')}} %</h3>
                  <v-text-field
                    outline
                    v-model="editedProductItemsItem.DiscountPercentage"
                    :label="$translate('DISCOUNT') + '%'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs5>
                  <h3>{{$translate('ITEM_NUMBER')}}</h3>
                  <v-text-field
                    outline
                    type="number"
                    v-model="editedProductItemsItem.ItemNumber"
                    :label="$translate('ITEM_NUMBER')"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" round @click="closeItemsDialog">{{$translate('CANCEL')}}</v-btn>
          <v-btn color="primary" round @click="saveProductItem(editedProductItemsItem)">{{$translate('SAVE')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="stockDialog" max-width="290" persistent hide-overlay>
      <v-card>
        <v-card-title
          v-if="selectedObject.hasOwnProperty('Name')"
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{selectedObject.Name}}</v-card-title>
        <v-card-title
          v-else
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{$translate('CHANGE_STOCK')}}</v-card-title>
        <v-card-text>{{stockDialogText}}</v-card-text>
        <v-layout justify-center>
          <v-flex xs10>
            <v-text-field
              v-if="selectedObject.InStock"
              v-model="selectedObject.Capacity"
              type="number"
              min="0"
              @input="checkCapacityValue"
              outline
              :label="$translate('EVENT_CAP_SHORT')"></v-text-field>
            <p style="color:red"><i>{{stockErrorText}}</i></p>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="v-btn-2 text-capitalize"
            round
            @click.native="exitChangeStock"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn
            color="primary"
            class="v-btn-2 text-capitalize"
            round
            @click.native="changeStock"
          >{{$translate('CONFIRM')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ProductDiscountDialog
      v-if="discountDialogActive"
      :productProp="productConfig"
      :eventId="eventConfig.eventId"
      @product-discount-dialog-closed="productDiscountDialogClosedHandler"
      @product-discount-updated="productDiscountUpdatedHandler"
    />
  </div>
</template>

<script>
import * as dssRequest from '@/api/dssRequest';
import CreateEventObject2 from '@/objects/CreateEventObject2';
import _ from 'lodash';
import { objectToArray } from '@/shared/utility.js';
import BaseComponent from '@/components/base/BaseComponent.vue';
import ProductDiscountDialog from '@/components/ProductDiscountDialog';
import appConfig from '../../../config/app_config';
import ProductObject from '../../objects/ProductObject';
import { ui_helpers } from '../../shared/ui_helpers';
import EventImageLoader from '../media/EventImageLoader';
import ExpendableTags from '../ExpendableTags';
import Generic_Translations from '../Generic_Translations';

export default {
  extends: BaseComponent,
  mixins: [ui_helpers],
  name: 'Events_Products',
  components: {
    // Importing the components that are used within this component
    Generic_Translations,
    EventImageLoader,
    ExpendableTags,
    ProductDiscountDialog,
  },
  computed: {
    options: () => this.editedProductItemsItem.ItemDefs,
    computedDateFormattedStartDate() {
      return this.formatDate(this.tmpStartDate);
    },
    computedDateFormattedEndDate() {
      return this.formatDate(this.tmpEndDate);
    },
    formTitle() {
      return this.editedIndex === -1 ? 'New Batchgroup' : 'Edit Batchgroup';
    },
    productAspectTitle() {
      return this.editedProductAspectIndex === -1
        ? 'New product aspect'
        : 'Edit product aspect';
    },
    productItemTitle() {
      return this.editedProductItemsIndex === -1
        ? 'New product item'
        : 'Edit product item';
    },
    formTicketTitle() {
      return this.editedPriceCategoriesIndex === -1
        ? 'New price categorie'
        : 'Edit price categorie';
    },
  },
  watch: {
    itemsDialog(val) {
      val || this.closeItemsDialog();
    },
    aspectsDialog(val) {
      val || this.closeAspectsDialog();
    },
    editMode(newVal, oldVal) {
      this.editMode = newVal;
      if (this.$refs.productForm !== undefined) {
        this.$refs.productForm.resetValidation();
      }
    },
    eventConfig: {
      handler(newVal) {
        if (this.$refs.productForm !== undefined) {
          this.$refs.productForm.resetValidation();
        }
      },
      deep: true,
    },

    productConfig: {
      handler(newVal) {
        const productFormTmp = ProductObject._objectDefinition(newVal);
        this.productForm = _.cloneDeep(productFormTmp);

        console.log('Brian this.productForm', this.productForm);

        this.properties2.pictureUrl = this.productForm.Picture;

        if (this.$refs.productForm !== undefined) {
          this.$refs.productForm.resetValidation();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      selectedProduct: {},
      productTranslations: {},
      productColumns: [],
      openProductTranslations: false,

      // External calendar
      externalCalendarToBeDeleted: {},
      editedExternalCalendarIndex: -1,
      externalCalendarItems: [],
      completeTime: false,
      editedExternalCalendarItem: {},
      externalCalendarDialog: false,
      deleteExternalCalendarDialog: false,
      externalCalendarHeaders: [
        {
          text: this.$translate('NAME'),
          align: 'left',
          sortable: false,
          value: 'Name',
        },
        {
          text: 'ExportUrl', align: 'left', value: 'ExportUrl', sortable: false,
        },
        {
          text: this.$translate('EVENT_CHECK_IN_TIME'), align: 'left', value: 'CheckInTime', sortable: false,
        },
        {
          text: this.$translate('EVENT_CHECK_OUT_TIME'), align: 'left', value: 'CheckOutTime', sortable: false,
        },
        {
          text: 'Complete time', align: 'left', value: 'CompleteTime', sortable: false,
        },
        {
          text: this.$translate('EVENT_ACTIONS'), align: 'right', value: 'Url', sortable: false,
        },
      ],
      // Stock dialog
      stockErrorText: '',
      selectedObject: {},
      stockDialog: false,
      stockDialogText: '',
      // Product categories
      productCategories: [],
      selectedProductCategoryId: -1,
      // Price categories
      editPriceCategory: false,
      defaultPriceCategoriesItem: {
        Name: '',
        Price: '',
      },
      deleteProductPriceCategoryDialog: false,
      priceCategoryToBeDeleted: {},

      // Items
      chosenItems: [],
      itemToBeDeleted: {},
      deleteProductItemDialog: false,
      editedProductItemsIndex: -1,
      editedProductItemsItem: {},
      selectedProductForItems: {},
      productItems: [],
      addProductItem: false,
      editProductItem: false,
      itemsDialog: false,
      priceCategoriesHeaders: [
        {
          text: this.$translate('NAME'),
          align: 'left',
          sortable: false,
          value: 'Name',
        },
        {
          text: this.$translate('PRICE2'), align: 'left', value: 'Price', sortable: false,
        },
        {
          text: this.$translate('EVENT_ACTIONS'), align: 'right', value: 'Price', sortable: false,
        },
      ],
      itemsHeader: [
        {
          text: this.$translate('PRODUCT_IN_STOCK'), align: 'left', sortable: false, value: 'Capacity',
        },
        {
          text: 'Item-Id', align: 'left', sortable: false, value: 'Id',
        },
        { text: this.$translate('ASPECTS'), sortable: false, value: 'Choices' },
        { text: this.$translate('PRICE2'), value: 'Price', sortable: false },
        { text: this.$translate('EVENT_CAP_SHORT'), value: 'Capacity', sortable: false },
        { text: `${this.$translate('DISCOUNT')} %`, value: 'DiscountPercentage', sortable: false },
        {
          text: this.$translate('EVENT_ACTIONS'), align: 'center', value: 'Name', sortable: false,
        },
      ],
      // The properties for the add photo wizard
      itemPictureProperties: {
        title: 'Background',
        signalName: 'load_image',
        deletable: false,
        pictureUrl: '',
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: 'w',
      },

      // Aspects
      deleteProductAspectDialog: false,
      aspectToBeDeleted: {},
      editProductAspectChoice: false,
      editedProductAspectChoiceItem: {},
      editedProductAspectChoiceIndex: -1,
      addProductAspectChoice: false,
      editedProductAspectIndex: -1,
      editedProductAspectItem: {},
      addProductAspect: false,
      editProductAspect: false,
      productAspects: [],
      selectedAspect: {},
      aspectsDialog: false,
      aspectsHeader: [
        {
          text: this.$translate('NAME'),
          align: 'left',
          sortable: false,
          value: 'Name',
        },
        { text: this.$translate('CHOICES'), value: 'Choices', sortable: false },
        {
          text: this.$translate('EVENT_ACTIONS'), align: 'center', value: 'Name', sortable: false,
        },
      ],

      headers: [
        {
          text: this.$translate('PRODUCT_IN_STOCK'), align: 'left', sortable: false, value: 'Name',
        },
        {
          text: this.$translate('NAME'), align: 'left', sortable: true, value: 'Name',
        },
        {
          text: this.$translate('CATEGORIES'),
          align: 'center',
          sortable: false,
          value: 'Categories',
        },
        {
          text: this.$translate('ASPECTS'), align: 'center', sortable: false, value: 'Aspects',
        },
        {
          text: this.$translate('ITEMS'), align: 'center', sortable: false, value: 'Items',
        },
        { text: this.$translate('DISCOUNT'), align: 'center', sortable: false },
        { text: this.$translate('EVENT_ACTIONS'), align: 'center', sortable: false },
      ],

      // The properties for the add photo wizard
      properties2: {
        title: 'Background',
        signalName: 'load_image',
        deletable: false,
        pictureUrl: '',
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: 'w',
      },

      policies: [],
      potentialPriceCategories: [],
      batchgroupPriceCategories: [],
      editedPriceCategoriesItem: {},
      editedPriceCategoriesIndex: -1,
      priceCategoriesDialog: false,
      newPriceCategorie: false,
      errorPriceCategoriesDialog: false,
      wrongDateDialog: false,
      startTimePicker: false,
      endTimePicker: false,
      eventForm: {},
      productConfig: {},
      eventConfig: {},
      daySelected: [],
      disableAdd: true,
      tmpStartDate: null,
      tmpEndDate: null,
      current_date: null,
      productToBeDelete: {},
      deleteProductDialog: false,
      textRule: [
        (v) => !!v || 'Field is required',
        // v => v != 0 || "Field must at least be 1 char long!"
      ],
      comboRule: [(v) => !!v || 'Date(s) are required'],
      numberRule: [(v) => v >= 0 || 'Field is required and must be positive'],
      menu: false,
      menu3: false,
      menu4: false,
      tmpEndDate2: null,
      selectDates: [],
      productForm: ProductObject._objectDefinition(),
      productList: [],
      filteredProductList: [],
      valid: true,
      openAddProduct: false,
      userGroupIdToBeDeleted: -1,
      dialogDelete: false,
      deleteDisable: false,
      editedItem: {},
      editedIndex: -1,
      radioSelect: null,
      dialog: false,
      errorDialog: false,
      editMode: false,
      roles: [],
      disableButton: true,
      colors: '',

      defaultItem: {
        description: '',
      },
      productTypes: ['Standard', 'Weighted'],
      discountDialogActive: false,
    };
  },
  mounted() {},
  created() {
    window.EventBus.listen('dataForComponent', this.manageDataForComponent);
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      'dataForComponent',
      this.manageDataForComponent,
    );
  },
  methods: {
    saveProductCalendar(data) {
      if (this.externalCalendarItems.length === 0) return;
      console.log('Lorenzo this.externalCalendarItems', this.externalCalendarItems);
      console.log('Lorenzo this.selectedProductForItems', this.selectedProductForItems);
      const payload = {
        Calendar: this.externalCalendarItems,
        ProductId: data.ProductId,
        EventId: this.eventConfig.eventId,
      };
      console.log('Lorenzo payload', payload);
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call for saveProductCalendar on - Events_Products.vue - was successful',
            response,
          );
        },
        (error) => {
          console.log(
            'The generic call for saveProductCalendar on - Events_Products.vue - was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveProductCalendar',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    copyAutomatic() {
      const copyText = document.getElementById('myInput');
      copyText.select();
      document.execCommand('copy');
      window.EventBus.fire(
        'activateSnackBar',
        'Copied',
      );
    },
    deleteExternvalCalendar(item) {
      this.externalCalendarItems.forEach((element, index) => {
        if (element.Name == item.Name) {
          this.externalCalendarItems.splice(index, 1);
        }
      });
      this.deleteExternalCalendarDialog = false;
    },
    triggerDeleteExternalCalendar(item) {
      this.deleteExternalCalendarDialog = true;
      this.externalCalendarToBeDeleted = item;
    },
    saveExternalCalendar() {
      if (this.editedExternalCalendarIndex > -1) {
        this.editedExternalCalendarItem.CompleteTime = this.completeTime;
        Object.assign(
          this.externalCalendarItems[this.editedExternalCalendarIndex],
          this.editedExternalCalendarItem,
        );
      } else {
        this.editedExternalCalendarItem.CompleteTime = this.completeTime;
        this.externalCalendarItems.push(this.editedExternalCalendarItem);
      }
      console.log('Lorenzo this.editedExternalCalendarItem', this.editedExternalCalendarItem);
      this.editedExternalCalendarIndex = -1;
      this.closeExternalCalendardialog();
      this.editedExternalCalendarItem = {};
    },
    closeExternalCalendardialog() {
      this.externalCalendarDialog = false;
      this.completeTime = false;
    },
    addNewExternalCalendar() {
      this.externalCalendarDialog = true;
    },
    triggerEditExternalCalendar(item) {
      // Editing the price category of a product
      this.editedExternalCalendarIndex = this.externalCalendarItems.indexOf(
        item,
      );
      console.log('Lorenzo this.editedExternalCalendarIndex', this.editedExternalCalendarIndex);
      this.editedExternalCalendarItem = { ...item };
      this.externalCalendarDialog = true;
    },
    savePriceCategories() {
      if (this.editedPriceCategoriesIndex > -1) {
        Object.assign(
          this.batchgroupPriceCategories[this.editedPriceCategoriesIndex],
          this.editedPriceCategoriesItem,
        );
      } else {
        this.potentialPriceCategories.forEach((e) => {
          if (this.editedPriceCategoriesItem.Name == e.Name) {
            this.editedPriceCategoriesItem.Id = e.Id;
          }
        });
        this.editedPriceCategoriesItem.Active = 1;
        this.batchgroupPriceCategories.push(this.editedPriceCategoriesItem);
      }
      this.closePriceCategoriesdialog();
    },
    closePriceCategoriesdialog() {
      this.priceCategoriesDialog = false;
      this.newPriceCategorie = false;
      setTimeout(() => {
        this.editedPriceCategoriesItem = {

          ...this.defaultPriceCategoriesItem,
        };
        this.editedPriceCategoriesIndex = -1;
      }, 300);
    },
    addNewPriceCategory() {
      this.getPriceCategories();
      this.priceCategoriesDialog = true;
      this.newPriceCategorie = true;
      this.editPriceCategory = false;
    },
    deleteProductPriceCategory(item) {
      this.batchgroupPriceCategories.forEach((element, index) => {
        if (element.Name == item.Name) {
          this.batchgroupPriceCategories.splice(index, 1);
        }
      });
      this.deleteProductPriceCategoryDialog = false;
    },
    triggerEditPriceCategories(item) {
      // Editing the price category of a product
      this.editedPriceCategoriesIndex = this.batchgroupPriceCategories.indexOf(
        item,
      );
      this.editedPriceCategoriesItem = { ...item };
      this.priceCategoriesDialog = true;
      this.newPriceCategorie = true;
      this.editPriceCategory = true;
    },
    getPriceCategories() {
      const payload = {
        EventId: this.eventConfig.eventId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call getPriceCategories was successful',
            response,
          );
          this.potentialPriceCategories = [];
          if (!_.isEmpty(response.data.Tickets)) {
            for (const [key, value] of Object.entries(response.data.Tickets)) {
              let alreadyInside = false;
              for (const [
                elementKey,
                element,
              ] of this.batchgroupPriceCategories.entries()) {
                console.log('element and value: ', element, value);
                if (element.Id == value.Id) {
                  alreadyInside = true;
                  break;
                }
              }
              console.log('alreadyInside: ', alreadyInside);
              if (!alreadyInside) {
                this.potentialPriceCategories.push(value);
              }
            }
          } else {
            console.log(' recieved data is empty');
          }
        },
        (error) => {
          console.log(
            'The generic call getPriceCategories was not successful',
            error,
          );
        },
        'getPriceCategories',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    triggerDeletePriceCategory(item) {
      this.deleteProductPriceCategoryDialog = true;
      this.priceCategoryToBeDeleted = item;
    },
    setVModel(returningValue) {
      if (Object.keys(this.editedProductItemsItem).length > 0) {
        for (const [key, value] of Object.entries(
          this.editedProductItemsItem.ItemDefs,
        )) {
          console.log(
            'Brian item, index on 2.0 version',
            key,
            value,
            returningValue,
          );

          if (returningValue == key) {
            this.selectedProductForItems.ItemDefs[key].Value = value;
          }
        }
      }
    },
    saveProductItem(item) {
      console.log(
        'Brian the recieved item',
        this.selectedProductForItems.ItemDefs,
        this.editedProductItemsItem,
      );

      // Saving the product item
      const obj = item;
      const array = [];
      for (const [key, value] of Object.entries(
        this.selectedProductForItems.ItemDefs,
      )) {
        array.push({
          Id: key,
          ItemValue: value.Value,
        });
      }
      const mapped = array.map((item) => ({ [item.Id]: item.ItemValue }));
      const newObj = Object.assign({}, ...mapped);

      const payload = {};
      if (this.editProductItem) {
        if (Object.keys(this.editedProductItemsItem.ItemDefs).length > 0) {
          this.payload = {
            ItemId: this.editedProductItemsItem.Id,
            ItemNumber: Number(this.editedProductItemsItem.ItemNumber),
            ProductId: this.selectedProductForItems.Id,
            Price: this.editedProductItemsItem.Price,
            Capacity: this.editedProductItemsItem.Capacity,
            DiscountPercentage: this.editedProductItemsItem.DiscountPercentage,
            Picture: this.itemPictureProperties.pictureUrl,
            ItemDefs: newObj,
          };
        } else {
          this.payload = {
            ItemId: this.editedProductItemsItem.Id,
            ItemNumber: Number(this.editedProductItemsItem.ItemNumber),
            ProductId: this.selectedProductForItems.Id,
            Price: this.editedProductItemsItem.Price,
            Capacity: this.editedProductItemsItem.Capacity,
            DiscountPercentage: this.editedProductItemsItem.DiscountPercentage,
            Picture: this.itemPictureProperties.pictureUrl,
            ItemDefs: newObj,
          };
        }
      } else {
        this.payload = {
          ProductId: this.selectedProductForItems.Id,
          Price: this.editedProductItemsItem.Price,
          ItemNumber: Number(this.editedProductItemsItem.ItemNumber),
          Capacity: this.editedProductItemsItem.Capacity,
          DiscountPercentage: this.editedProductItemsItem.DiscountPercentage,
          Picture: this.itemPictureProperties.pictureUrl,
          ItemDefs: newObj,
        };
      }

      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call saveProductItem was successful',
            response,
          );
          if (this.selectedObject.hasOwnProperty('Id')) {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('STOCK_ITEM_SUC_CHANGED'),
            );
            this.selectedObject = {};
            this.itemPictureProperties.pictureUrl = '';
            this.properties2.pictureUrl = '';
          }
          this.itemsDialog = false;
          this.getProducts(this.eventConfig);
        },
        (error) => {
          console.log(
            'The generic call saveProductItem was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveProductItem',
        appConfig.dss.eventAdminMng,
        this.payload,
      );
    },
    closeItemsDialog() {
      // closing the items dialog
      this.addProductItem = false;
      setTimeout(() => {
        this.editedProductItemsItem = {};
      }, 300);
    },
    returnItemsInObject(item) {
      console.log(
        'Brian hjhhjhjhjhjjitem',
        item,
        this.editedProductItemsItem,
        this.selectedProductForItems,
        this.editProductItem,
      );
      const obj = {};
      const array = [];
      for (const [key, value] of Object.entries(item)) {
        array.push({
          Id: key,
          Name: value,
        });
      }

      return array;
    },
    cancelProductItemsDialog() {
      // Closing the product items dialog
      this.itemsDialog = false;
    },
    openItemsDialog(data) {
      // Edit/Add/Delete items dialog
      console.log('data in openItemsDialog: ', data);
      this.selectedProductForItems = data;
      this.selectedProductForItems.ChosenItems = {};
      this.productItems = [];
      // for (const [key, value] of Object.entries(
      //   this.selectedProductForItems.Items
      // )) {
      //   this.productItems.push({
      //     Id: value.Id,
      //     Aspects: Object.values(value.ItemDefs),
      //     AspectsString: Object.values(value.ItemDefs).join(),
      //     ItemDefs: value.ItemDefs,
      //     Price: value.Price,
      //     Capacity: value.Capacity,
      //     DiscountPercentage: value.DiscountPercentage,
      //     ItemNumber: value.ItemNumber
      //   });
      // }

      for (const item of this.selectedProductForItems.Items) {
        this.productItems.push({
          Id: item.Id,
          Aspects: Object.values(item.ItemDefs),
          AspectsString: Object.values(item.ItemDefs).join(),
          ItemDefs: item.ItemDefs,
          Price: item.Price,
          Capacity: item.Capacity,
          DiscountPercentage: item.DiscountPercentage,
          ItemNumber: item.ItemNumber,
        });
      }

      this.itemsDialog = true;
    },
    addNewProductItem() {
      // Add new item
      this.addProductItem = true;
      this.editProductItem = false;
    },
    triggerDeleteAspectDialog(item) {
      this.aspectToBeDeleted = item;
      this.deleteProductAspectDialog = true;
    },
    triggerDeleteProductItem(item) {
      this.itemToBeDeleted = item;
      this.deleteProductItemDialog = true;
    },
    deleteProductItem(item) {
      console.log(
        'Brian this.selectedProductForItems, item',
        this.selectedProductForItems,
        item,
      );

      const payload = {
        ProductId: this.selectedProductForItems.Id,
        ItemId: item.Id,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call deleteProductItem was successful',
            response,
          );
          this.itemsDialog = false;
          this.getProducts(this.eventConfig);
        },
        (error) => {
          console.log(
            'The generic call deleteProductItem was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'deleteProductItem',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    deleteProductAspect(item) {
      console.log('Laurens i got to deleteProductAspect', this.productAspects);

      this.productAspects.forEach((element, index) => {
        if (element.Name == item.Name) {
          this.productAspects.splice(index, 1);
        }
      });
      this.saveProductAspects();
      this.deleteProductAspectDialog = false;
    },
    saveProductAspectChoice(item) {
      this.productAspects.push({
        Name: item.Name,
        Choices: item.Choices,
        ChoicesString: item.Choices.join(),
      });
      this.addProductAspect = false;
    },
    saveProductAspectChoiceTmp(item) {
      // saving the choice in tmp to the aspect
      if (!this.editedProductAspectItem.hasOwnProperty('Choices')) {
        this.editedProductAspectItem.Choices = [];
      }
      this.editedProductAspectItem.Choices.push(item.Name);
      this.addProductAspectChoice = false;
      this.editedProductAspectChoiceItem = {};
    },
    addNewProductAspectChoice() {
      // Add new product aspect choice
      this.addProductAspectChoice = true;
      this.editProductAspectChoice = false;
    },
    editingProductAspectChoice(item) {
      // editing the product aspect (itemDefs)
      console.log('Laurens this.productAspects before', this.productAspects);
      this.productAspects = [];
      this.productAspects.push({
        Name: item.Name,
        Choices: item.Choices,
        ChoicesString: item.Choices.join(),
      });
      console.log('Laurens this.productAspects after', this.productAspects);
      this.addProductAspect = false;
    },
    returnTheChoices(item) {
      const obj = {};
      item.forEach((element, index) => {
        obj[index] = element;
      });
      return obj;
    },
    saveProductAspects() {
      // Saving the product aspect (itemDefs)
      const obj = {};
      for (const value of this.productAspects) {
        obj[value.Name] = this.returnTheChoices(value.Choices);
      }
      const payload = {
        ProductId: this.selectedAspect.Id,
        ItemDefs: obj,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call saveItemDefs was successful',
            response,
          );
          this.aspectsDialog = false;
          this.getProducts(this.eventConfig);
        },
        (error) => {
          console.log(
            'The generic call saveItemDefs was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveItemDefs',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    cancelProductAspectsDialog() {
      // Closing the product aspects dialog
      this.aspectsDialog = false;
    },
    closeAspectsDialog() {
      // closing the aspects dialog
      this.addProductAspect = false;
      setTimeout(() => {
        this.editedProductAspectItem = {};
      }, 300);
    },
    triggerEditProductItem(item) {
      this.editedProductItemsIndex = this.productItems.indexOf(item);
      this.editedProductItemsItem = { ...item };
      this.addProductItem = true;
      this.editProductItem = true;
    },
    editProductAspectItem(item) {
      // Editing the aspect of an product
      this.editedProductAspectIndex = this.productAspects.indexOf(item);
      this.editedProductAspectItem = { ...item };
      this.addProductAspect = true;
      this.editProductAspect = true;
    },
    addNewProductAspect() {
      // Add new aspect
      this.addProductAspect = true;
      this.editProductAspect = false;
    },
    openAspectsDialog(data) {
      // Edit/Add/Delete aspects dialog
      this.productAspects = [];
      this.selectedAspect = data;
      for (const [key, value] of Object.entries(this.selectedAspect.ItemDefs)) {
        this.productAspects.push({
          Name: key,
          Choices: Object.values(value),
          ChoicesString: Object.values(value).join(),
        });
      }
      this.aspectsDialog = true;
    },
    setImageElement(e) {
      // If the properties are changed, the image changes regarding the new props
      if (e.signalName == this.properties2.signalName) {
        this.properties2.pictureUrl = e.url;
      }
    },
    setImageElementForItem(e) {
      // If the properties are changed, the image changes regarding the new props
      if (e.signalName == this.itemPictureProperties.signalName) {
        this.itemPictureProperties.pictureUrl = e.url;
      }
    },
    getProducts(detail) {
      if (detail.type === 'Standard') return;
      const payload = {};
      this.productAspects = [];
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getProducts was successful', response);
          delete response.data.ErrorMsg;
          this.filteredProductList = objectToArray(response.data.Products);
          this.filteredProductList.forEach((element) => {
            let TagsArray = [];
            let itemDefArray = [];
            itemDefArray = Object.keys(element.ItemDefs);
            TagsArray = Object.values(element.Categories);
            element.ItemDefString = itemDefArray.join();
            element.TagsString = TagsArray.join();
          });
        },
        (error) => {
          console.log(
            'The generic call getProducts was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'getProductsV2',
        detail.eventId,
        payload,
      );
    },
    checkCapacityValue() {
      if (this.selectedObject.Capacity < 1) {
        // User has given a minus number for the capacity
        this.stockErrorText = this.$translate('VALID_CAPACITY');
      } else {
        this.stockErrorText = '';
      }
    },
    closeProductTranslations() {
      this.selectedProduct = {};
      this.openProductTranslations = false;
    },
    saveProductTranslations(translationData) {
      const payload = {};
      payload.Translations = translationData;
      payload.ProductId = this.selectedProduct.Id;
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The call for saveProductTranslations on - Events_Products.vue - was successful',
            response,
          );
          this.openProductTranslations = false;
          this.selectedProduct = {};
        },
        (error) => {
          console.log(
            'The call for saveProductTranslations on - Events_Products.vue - was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveProductTranslations',
        this.eventConfig.eventId,
        payload,
      );
    },
    savingProduct() {
      console.log('productForm to be saved: ', this.productForm);
      if (this.productForm.Brand === undefined) {
        this.productForm.Brand = '';
      }
      console.log("Lorenzo this.productForm.Capacity", this.productForm.Capacity);
      if (!this.$refs.productForm.validate()) {
        this.errorDialog = true;
        return;
      }


      const toStorePriceCategories = {};
      if (this.batchgroupPriceCategories.length > 0) {
        this.batchgroupPriceCategories.forEach((e) => {
          toStorePriceCategories[Number(e.Id)] = {
            Price: Number(e.Price).toFixed(2),
            Name: e.Name,
            Active: e.Active,
          };
        });
        this.productForm.PriceCategories = toStorePriceCategories;
      }
      let payload = {};
      this.productForm.Picture = this.properties2.pictureUrl;
      if (!this.productForm.hasOwnProperty('ProductCategory')) {
        if (this.productForm.hasOwnProperty('Categories')) {
          if (Object.keys(this.productForm.Categories).length > 0) {
            this.productForm.ProductCategory = {
              id: Number(Object.keys(this.productForm.Categories)[0]),
              description: Object.values(this.productForm.Categories)[0],
            };
          }
        } else {
          this.productForm.ProductCategory = {};
        }
      }
      console.log('productForm in savingProduct: ', this.productForm);

      payload = ProductObject._createProductObject(
        this.productForm,
        this.eventConfig,
      );
      payload.ExternalSynchronisation = this.productConfig.ExternalSynchronisation;
      dssRequest.doRequest(
        (response) => {
          console.log(
            'The generic call for saveProduct was successful',
            response,
          );
          this.saveProductCalendar(response.data);
          if (this.selectedObject.hasOwnProperty('Id')) {
            window.EventBus.fire(
              'activateSnackBar',
              this.$translate('STOCK_PRO_SUC_CHANGED'),
            );
            this.selectedObject = {};
            this.itemPictureProperties.pictureUrl = '';
          }
          const get = { reload: true };
          this.signalCloseProductDialog(get);
          this.getProducts(this.eventConfig);
          const x = {};
          x.Id = response.data.ProductId;
          setTimeout(() => {
            this.getProductTranslations(x);
          }, 30);
        },
        (error) => {
          console.log(
            'The generic call for saveProduct was not successful',
            error,
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'saveProduct',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },

    showDeleteProductDialog(item) {
      this.productToBeDelete = item;
      this.deleteProductDialog = true;
    },
    deleteProduct() {
      // Deleting the product
      const payload = {
        ProductId: this.productToBeDelete.Id,
      };

      dssRequest.doRequest(
        (response) => {
          console.log('The call deleteProduct was successful', response);
          this.deleteProductDialog = false;
          this.getProducts(this.eventConfig);
        },
        (error) => {
          console.log('The call deleteProduct was not succesfull', error);
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        'deleteProduct',
        appConfig.dss.eventAdminMng,
        payload,
      );
    },
    viewProductDetails(item) {
      const productDetails = _.cloneDeep(item);
      this.getPriceCategories();
      this.editMode = true;
      console.log('Brian productDetails', productDetails);
      if (this.eventConfig.type === 'Rental' && productDetails.hasOwnProperty('ExternalCalendars')) {
        this.externalCalendarItems = [];
        for (const [index, item] of Object.entries(productDetails.ExternalCalendars)) {
          this.externalCalendarItems.push(item);
        }
      }
      this.productConfig = productDetails;
      this.batchgroupPriceCategories = [];

      // Set selected ProductCategory
      const categoryArray = Object.keys(this.productConfig.Categories);
      if (categoryArray.length === 0) {
        this.selectedProductCategoryId = -1;
      } else {
        for (let i = 0; i < this.productCategories.length; ++i) {
          if (Number(categoryArray[0]) === this.productCategories[i].id) {
            this.selectedProductCategoryId = Number(categoryArray[0]);
            break;
          }
        }
      }

      if (productDetails.hasOwnProperty('PriceCategories')) {
        Object.values(productDetails.PriceCategories).forEach((priceCatagory) => {
          this.batchgroupPriceCategories.push({
            Name: priceCatagory.Name,
            Price: priceCatagory.Price,
            Id: priceCatagory.Id,
            Active: priceCatagory.Active,
          });
        });
      }

      this.openAddProduct = true;
    },
    getProductTranslations(product) {
      console.log('Brian product', product);

      const payload = {
        ProductId: product.Id,
      };
      dssRequest.doRequest(
        (response) => {
          console.log('The generic call getProductTranslations was successful', response);
          this.productTranslations = {};
          this.productColumns = [];
          this.selectedproduct = {};
          this.productTranslations = response.data.Translations;
          this.productColumns = response.data.ColumnNames;
          this.openProductTranslations = true;
          this.selectedProduct = product;
        },
        (error) => {
          console.log('The generic call getProductTranslations was not successful', error);
        },
        'getProductTranslations',
        this.eventConfig.eventId,
        payload,
      );
    },
    exitChangeStock() {
      this.filteredProductList = [];
      this.getProducts(this.eventConfig);
      this.selectedObject = {};
      this.itemPictureProperties.pictureUrl = '';
      this.properties2.pictureUrl = '';
      this.stockDialog = false;
      this.stockErrorText = '';
    },
    signalCloseProductDialog(get) {
      // this.$refs.form.reset();
      window.EventBus.fire('closeProductsDialog', get);
      this.openAddProduct = false;
    },
    manageDataForComponent(data) {
      this.eventForm = data;
      this.eventConfig = data;

      console.log(
        'Received data in manageDataForComponent of Events_Products: ',
        data,
      );

      if (!_.isEmpty(data)) {
        this.getProducts(data);
        this.disableFields(true);
        if (this.eventConfig.productCategories !== undefined) {
          for (const [key, value] of Object.entries(
            this.eventConfig.productCategories,
          )) {
            this.productCategories.push(value);
          }
        }
        if (this.eventConfig.memberOf !== undefined) {
          this.eventConfig.memberOf.forEach((e) => {
            console.log('Brian eeeeeeee', e);

            if (
              e.grantType === 'OWNER'
              && e.accountId == this.currentAccountId
            ) {
              this.disableFields(false);
            }
          });
        } else {
          this.disableFields(true);
        }
      } else {
        this.eventForm = CreateEventObject2._objectDefinition();
      }
    },
    disableFields(status) {
      this.disableAdd = status;
    },
    addProduct() {
      const freshInput = {
        eventId: this.eventConfig.eventId,
        locationId: this.eventConfig.locationId,
        type: this.eventConfig.type,
      };
      this.editMode = false;
      this.batchgroupPriceCategories = [];
      this.eventConfig = freshInput;
      this.productConfig = {};
      this.openAddProduct = true;
    },
    closeProductsDialog(params) {
      this.editMode = false;
      this.openAddProduct = false;
      if (params.reload == true) {
        this.getProducts(this.eventConfig);
      }
    },
    changeStock() {
      if (!this.selectedObject.InStock) {
        // User sets selected Object to out of stock, so we set the capacity to 0
        this.selectedObject.Capacity = 0;
      } else if (this.selectedObject.Capacity < 1) {
        return;
      }
      console.log('selectedObject in changeStock: ', this.selectedObject);

      if (this.selectedObject.Product) {
        // The selected Object is a product
        this.stockErrorText = '';
        delete this.selectedObject.Product;
        delete this.selectedObject.InStock;
        this.stockDialog = false;
        this.editMode = true;
        this.productConfig = this.selectedObject;
        this.productForm = this.selectedObject;
        this.properties2.pictureUrl = this.selectedObject.Picture;
        this.savingProduct();
      } else {
        // The selected Object is an product-item
        this.stockErrorText = '';
        delete this.selectedObject.Product;
        delete this.selectedObject.InStock;
        this.stockDialog = false;
        this.editProductItem = true;
        this.editedProductItemsIndex = this.productItems.indexOf(this.selectedObject);
        this.editedProductItemsItem = { ...this.selectedObject };
        for (const [key, value] of Object.entries(this.selectedObject.ItemDefs)) {
          this.selectedProductForItems.ItemDefs[key].Value = value;
        }
        this.itemPictureProperties.pictureUrl = this.editedProductItemsItem.Picture;
        this.saveProductItem(this.editedProductItemsItem);
      }
    },
    outOfStockProducts(product) {
      console.log('Brian product', product);
      // make sure that the photo and product is cleared
      this.selectedObject = {};
      this.properties2.pictureUrl = '';
      this.itemPictureProperties.pictureUrl = '';

      // filled with the selected product data
      this.selectedObject = product;
      this.properties2.pictureUrl = this.selectedObject.Picture;
      if (product.Capacity !== 0) {
        this.selectedObject.InStock = false;
        this.selectedObject.Product = true;
        this.stockDialog = true;
        this.stockDialogText = this.$translate('CONFIRM_PRODUCT_PART_1') + product.Name + this.$translate('CONFIRM_PRODUCT_PART_2');
      } else {
        this.selectedObject.InStock = true;
        this.selectedObject.Product = true;
        this.stockDialog = true;
        this.stockDialogText = this.$translate('ENTER_NEW_PRO_STOCK') + product.Name;
      }
    },
    outOfStockItems(item) {
      console.log('Brian item', item);

      this.selectedObject = item;
      if (item.Capacity !== 0) {
        this.selectedObject.InStock = false;
        this.selectedObject.Product = false;
        this.stockDialog = true;
        this.stockDialogText = this.$translate('CONFIRM_ITEM');
      } else {
        this.selectedObject.InStock = true;
        this.selectedObject.Product = false;
        this.stockDialog = true;
        this.stockDialogText = this.$translate('ENTER_NEW_ITEM_STOCK');
      }
    },
    openDiscountDialog(product) {
      this.productConfig = _.cloneDeep(product);
      this.discountDialogActive = true;
    },
    productDiscountDialogClosedHandler() {
      this.discountDialogActive = false;
    },
    productDiscountUpdatedHandler() {
      this.discountDialogActive = false;
      this.getProducts(this.eventConfig);
    },
  },
};
</script>

<style lang="scss" scoped>
.choicesCard {
  min-height: 2em;
  border-radius: 2%;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.discountCard {
  border: 1px solid black !important;
}

.aspectsCard {
  min-height: 32em;
  width: 100%;
}

.scrollablleProductList {
  height: 30em;
  margin-bottom: 2em;
  overflow-x: hidden;
  overflow-y: auto;
}

.imageBorder {
  margin-left: 0em !important;
  max-width: 100%;
  border-radius: 2%;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.dialogAddBG {
  border-radius: 10px;
  max-width: 100%;
  overflow-y: hidden;
}

.dialogClass {
  margin-top: 4em;
  border-radius: 10px;
}

.lindaLogo {
  width: 17em;
  height: 30em;
}

.lindaTextMediumBatchgroup {
  max-height: 22em !important;
  margin-left: -2.5em !important;
  margin: 15px;
  border-radius: 1em !important;
  max-width: 21em !important;
}

.checkbox_lining {
  margin-left: -6em;
}

.selectedDays {
  margin-left: -0.5em;
}

.expendableCategories {
  border-radius: 2%;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.priceCategoriesCardTitle {
  margin-left: -5%;
}

.priceCategoriesCard {
  margin-left: -5%;
  width: 110%;
  margin-bottom: 2em;
  border: 2px solid rgba(0, 0, 0, 0.54) !important;
}
</style>
